export default "__VITE_ASSET__c0f87050__"